export default __webpack_public_path__ + "static/embed-popup-6cae909985bdd682ab85d15ca512b33f.png";